// Libraries
var React = require('react');
var utilGuid = require('../../common/utilGuid.js');

// Components
var GenericImage = require('../GenericImage/GenericImage');
var Icon = require('../../common/Icon/Icon.js');

// Style
require('./ListingCards.scss');

class ListingCardsModule extends React.Component {
  constructor(props) {

    super(props);

    let items = [];

    {this.props.data.cards.map((item, index) => {
      items.push(false);
    })}

    this.state = {
      items: items,
      language: this.getNavigatorLanguage()
    }

  }

  handleToggleCard(index) {

    let items = this.state.items;
    items[index] = !items[index];
    this.setState({ items: items });

  }

  getNavigatorLanguage() {

    const fallbackLanguage = 'en-GB';

    if (typeof navigator === "undefined") return fallbackLanguage;

    const navigatorLanguage = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || fallbackLanguage;

    if (navigatorLanguage === "en") {
      return fallbackLanguage;
    }

    return navigatorLanguage;

  }

  parseDate(date) {

    const jsDate = new Date(date);

    return jsDate.toLocaleDateString(this.state.language, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      year: 'numeric'
    });

  }

  camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
      if (+match === 0) return "";
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
  }

  render() {
    return (
      <div id={this.props.data.id} className={`c-section${this.props.data.isPremium ? " c-section--premium" : ""}${this.props.data.isFilters ? " c-section--tight-top" : ""}`}>
        <div className="c-section__inner">

          {this.props.data.title ?
            <h2 className="c-listing-cards__title">{this.props.data.title}</h2>
          : null}

          <div className={`c-listing-cards${this.props.data.isPremium ? " c-listing-cards--premium" : ""}`}>
            <div className="c-listing-cards__grid">

              {this.props.data.cards.map((item, index) => {
                const cardId = 'card-' + utilGuid.guid();
                const hasPrimaryIcons = item.parking || item.foodAndDrink || (item.seatingArea !== '');
                const hasSecondaryIcons = hasPrimaryIcons || (item.seatingType !== '');
                return (
                  <div className={`c-listing-cards__col${hasPrimaryIcons ? " c-listing-cards__col--with-icons" : ""}${(item.displayPrice !== "") ? " c-listing-cards__col--with-display-price" : ""}${item.fixture ? " c-listing-cards__col--with-fixture" : ""}`} key={index}>
                        <div className="c-listing-cards__col__inner">
                            <a href={item.link.url} className={`c-listing-cards__col__link${this.state.items[index] ? " c-listing-cards__col__link--hide" : ""}`} target={item.link.newWindow ? "_blank" : "_self"} rel={item.link.newWindow ? "noopener noreferrer" : undefined}>
                        <span className="u-visually-hidden">{item.title}</span>
                      </a>
                      <p className="c-listing-cards__toggle">
                        <button type="button" className="c-listing-cards__toggle__button" aria-expanded={this.state.items[index]} aria-controls={cardId}  onClick={this.handleToggleCard.bind(this, index)}>
						<span className="c-listing-cards__toggle__button__inner">{this.state.items[index] ? "Close" : "See your options"}</span>
                        <span className="u-visually-hidden"> - {item.title}</span>
                        </button>
                      </p>
                      <div className={`c-listing-cards__content${this.state.items[index] ? " c-listing-cards__content--visble" : ""}`}>
                        <div className="c-listing-cards__content__inner">
                          <div className="c-listing-cards__content__header">
                            {/* <p className="c-listing-cards__content__category">{ item.categories.join(' / ') }</p>
                            <p className="c-listing-cards__content__category">{ item.subcategories.join(' / ') }</p> */}
                            <p className="c-listing-cards__content__category">{ item.displayCategories.join(' / ') }</p>
                            <h3 className="c-listing-cards__content__title">
                              <span className="c-listing-cards__content__title__inner">{item.title}</span>
                            </h3>
                          </div>
                          <div className="c-listing-cards__content__body" aria-hidden={!this.state.items[index]} aria-labelledby={cardId}>
                            <p className="c-listing-cards__content__para">{item.text}</p>
                            {item.listTitle !== '' &&
                              <p className="c-listing-cards__content__list-title">{item.listTitle}</p>
                            }
                            {item.list.length &&
                              <ul className="c-listing-cards__content__list">
                                {item.list.map((listitem) => {
                                   return (
                                    <li key={listitem} className="c-listing-cards__content__list__item" dangerouslySetInnerHTML={{__html:listitem}}></li>
                                   )
                                })}
                              </ul>
                            }
                            {(item.displayPrice !== '') &&
                              <p className="c-listing-cards__content__price">{item.displayPrice}</p>
                            }
                            {item.fixture &&
                              <div className={`c-listing-cards__content__fixture`}>
                                <img className="c-listing-cards__content__fixture__crest" loading="lazy" src={item.fixture.homeTeam.lightCrest.smallUrl} alt={`${item.fixture.homeTeam.name} crest`} />
                                <span className="c-listing-cards__content__fixture__vs" aria-hidden="true">vs</span>
                                <img className="c-listing-cards__content__fixture__crest" loading="lazy" src={item.fixture.awayTeam.lightCrest.smallUrl} alt={`${item.fixture.awayTeam.name} crest`} />
                                <div className="c-listing-cards__content__fixture__text">
                                  <p className="c-listing-cards__content__fixture__title">{item.fixture.homeTeam.name} <abbr title="versus">vs</abbr> {item.fixture.awayTeam.name}</p>
                                  <p className="c-listing-cards__content__fixture__date">{this.parseDate(item.fixture.kickOff)}</p>
                                </div>
                              </div>
                            }
                            {hasSecondaryIcons &&
                              <ul className="c-listing-cards__content__icons">
                                {item.seatingArea &&
                                  <li className={`c-listing-cards__content__icons__item c-listing-cards__content__icons__item--${item.seatingArea}`}>
                                    <Icon className={`c-listing-cards__content__icons__icon c-listing-cards__content__icons__icon--${this.camelize(item.seatingArea)}`} name={this.camelize(item.seatingArea)} width={30} height={30} />
                                    <span className="c-listing-cards__content__icons__text">{item.seatingArea}</span>
                                  </li>
                                }
                                {item.foodAndDrink &&
                                  <li className="c-listing-cards__content__icons__item c-listing-cards__content__icons__item--foodAndDrink">
                                    <Icon className="c-listing-cards__content__icons__icon c-listing-cards__content__icons__icon--foodAndDrink" name="foodAndDrink" width={30} height={30} />
                                    <span className="c-listing-cards__content__icons__text">Food &amp; Drink</span>
                                  </li>
                                }
                                {item.parking &&
                                  <li className="c-listing-cards__content__icons__item c-listing-cards__content__icons__item--parking">
                                    <Icon className="c-listing-cards__content__icons__icon c-listing-cards__content__icons__icon--parking" name="parking" width={30} height={30} />
                                    <span className="c-listing-cards__content__icons__text">Parking</span>
                                  </li>
                                }
                                {item.seatingType &&
                                  <li className={`c-listing-cards__content__icons__item c-listing-cards__content__icons__item--${item.seatingType}`}>
                                    <Icon className={`c-listing-cards__content__icons__icon c-listing-cards__content__icons__icon--${this.camelize(item.seatingType)}`} name={this.camelize(item.seatingType)} width={30} height={30} />
                                    <span className="c-listing-cards__content__icons__text">{item.seatingType}</span>
                                  </li>
                                }
                              </ul>
                            }
                                        <p className="c-listing-cards__content__action">
                                            <a href={item.link.url} className={`c-button c-button--small c-button--on-dark${this.props.data.isPremium ? " c-button--premium" : ""}`} target={item.link.newWindow ? "_blank" : "_self"} rel={item.link.newWindow ? "noopener noreferrer" : undefined}>
                                {item.link.caption}<span className="u-visually-hidden"> - {item.title}</span>
                              </a>
                            </p>
                            {(item.secondaryLink && item.secondaryLink.url && item.secondaryLink.caption) &&
                                            <p className="c-listing-cards__content__action-secondary">
                                                <a href={item.secondaryLink.url} className="c-listing-cards__content__action-secondary__link" target={item.secondaryLink.newWindow ? "_blank" : "_self"}  rel={item.secondaryLink.newWindow ? "noopener noreferrer" : undefined}>
                                  {item.secondaryLink.caption}
                                </a>
                              </p>
                            }
                          </div>
                        </div>
                      </div>
                      {(hasPrimaryIcons && !this.state.items[index]) &&
                        <ul className="c-listing-cards__icons">
                          {item.seatingArea &&
                            <li className="c-listing-cards__icons__item">
                              <Icon className={`c-listing-cards__icons__icon c-listing-cards__icons__icon--${this.camelize(item.seatingArea)}`} name={this.camelize(item.seatingArea)} width={30} height={30} />
                              <span className="u-visually-hidden">{item.seatingArea}</span>
                            </li>
                          }
                          {item.foodAndDrink &&
                            <li className="c-listing-cards__icons__item">
                              <Icon className="c-listing-cards__icons__icon c-listing-cards__icons__icon--foodAndDrink" name="foodAndDrink" width={30} height={30} />
                              <span className="u-visually-hidden">Food &amp; Drink</span>
                            </li>
                          }
                          {item.parking &&
                            <li className="c-listing-cards__icons__item">
                              <Icon className="c-listing-cards__icons__icon c-listing-cards__icons__icon--parking" name="parking" width={30} height={30} />
                              <span className="u-visually-hidden">Parking</span>
                            </li>
                          }
                        </ul>
                      }
                      {(item.displayPrice !== '' && !this.state.items[index]) &&
                        <p className="c-listing-cards__price">{item.displayPrice}</p>
                      }
                      {item.fixture &&
                        <div className={`c-listing-cards__fixture${this.state.items[index] ? " c-listing-cards__fixture--hidden" : ""}`}>
                          <img className="c-listing-cards__fixture__crest" loading="lazy" src={item.fixture.homeTeam.lightCrest.smallUrl} alt={`${item.fixture.homeTeam.name} crest`} />
                          <span className="c-listing-cards__fixture__vs" aria-hidden="true">vs</span>
                          <img className="c-listing-cards__fixture__crest" loading="lazy" src={item.fixture.awayTeam.lightCrest.smallUrl} alt={`${item.fixture.awayTeam.name} crest`} />
                          <div className="c-listing-cards__fixture__text">
                            <p className="c-listing-cards__fixture__title">{item.fixture.homeTeam.name} <abbr title="versus">vs</abbr> {item.fixture.awayTeam.name}</p>
                            <p className="c-listing-cards__fixture__date">{this.parseDate(item.fixture.kickOff)}</p>
                          </div>
                        </div>
                      }
                      <GenericImage loading="lazy" image={item.image} class="c-listing-cards__image" />
                    </div>
                  </div>
                );
              })}
            
            </div>
          </div>

        </div>
      </div>
    );
  }
};

module.exports = ListingCardsModule;


// WEBPACK FOOTER //
// ./src/components/ListingCards/ListingCards.js